export const TextInputSkeleton = ({ customHeight }: { customHeight?: string }) => {
	return (
		<div className="w-full animate-pulse">
			<div className="h-4 w-1/4 rounded-sm bg-gray-300"></div>
			<div
				className={`mb-4 mt-2 ${
					customHeight ? customHeight : 'h-8'
				} rounded-sm bg-gray-300`}
			></div>
		</div>
	);
};
